import { QueryClient } from "@tanstack/react-query";

/**
 * Utility function to refresh all curriculum-related data
 * This should be called when curriculum master data is added/updated
 */
export const refreshAllCurriculumData = (queryClient: QueryClient, schoolId: string) => {
  // Invalidate curriculum management queries - use partial matching to catch all variations
  queryClient.invalidateQueries({
    queryKey: ["grade-management"],
    exact: false,
  });

  // Invalidate curriculum master queries
  queryClient.invalidateQueries({
    queryKey: ["curriculumMaster"],
  });

  // Invalidate curriculum master detail queries
  queryClient.invalidateQueries({
    queryKey: ["curriculumMasterDetail"],
  });

  console.log("All curriculum data refreshed globally");
};
